import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import BroadcastsListController from 'cio/pods/broadcasts/list-controller';

import AlertsService from 'cio/services/alerts';
import ApiErrorsService from 'cio/services/api-errors';
import TagModel from 'cio/models/tag';

export default class IndexController extends BroadcastsListController {
  @service apiErrors!: ApiErrorsService;
  @service alerts!: AlertsService;

  queryParams = [
    'search',
    'tagIds',
    'page',
    'sort',
    'asc',
    'state',
    'sendToUnsubscribed',
    'subscriptionTopicId',
    'objectTypeIds',
  ];

  @readOnly('broadcasts.meta.pagination.total') total!: number;

  @computed('search', 'tagIds')
  get hasAnyFilters() {
    return !isEmpty(this.search) || !isEmpty(this.tagIds);
  }

  setDefaultQueryParams() {
    super.setDefaultQueryParams();
    this.setProperties({
      tagIds: [],
    });
  }

  @action
  onTagClicked(tag: TagModel) {
    this.set('tagIds', [tag.id]);
  }

  @action
  onAddTags(tagIds: string[]) {
    this.set('tagIds', tagIds);
  }

  @action
  afterDeleteBroadcast() {
    this.send('reloadModel'); // reload route model to update pagination counts
  }

  @action
  onTopicChange(topic: { label: string; value: string } | null) {
    this.subscriptionTopicId = topic?.value ?? null;
  }
}
